import { gsap } from 'gsap';
import { lerp, getMousePos } from '../utils/utils';

// Track the mouse position
let mouse = {x: 0, y: 0};
window.addEventListener('mousemove', (ev) => mouse = getMousePos(ev));

export default class Cursor {
  constructor(el) {
    this.DOM = {el: el};
    this.DOM.el.style.opacity = 0;
    this.DOM.circle = this.DOM.el.querySelector('.cursor__circle');
    this.DOM.text = this.DOM.el.querySelector('.cursor__text');
    this.DOM.text.style.transform = 'scale(0)';
    this.bounds = this.DOM.el.getBoundingClientRect();
    // this.enableDefaultCursor = window.location.href.indexOf("spiriit.com") <= -1 && window.location.href.indexOf("choosit.com") <= -1 && window.location.href.indexOf("localhost") <= -1;
    this.enableDefaultCursor = 0;

    this.renderedStyles = {
      tx: {previous: 0, current: 0, amt: 0.2},
      ty: {previous: 0, current: 0, amt: 0.2},
      scale: {previous: this.enableDefaultCursor, current: this.enableDefaultCursor, amt: 0.2},
      opacity: {previous: 1, current: 1, amt: 0.2},
    };

    this.onMouseMoveEv = () => {
      this.renderedStyles.tx.previous = this.renderedStyles.tx.current = mouse.x - this.bounds.width/2;
      this.renderedStyles.ty.previous = this.renderedStyles.ty.previous = mouse.y - this.bounds.height/2 - window.scrollY;
      gsap.to(this.DOM.el, {duration: 0.9, ease: 'power3.out', opacity: 1});
      requestAnimationFrame(() => this.render());
      window.removeEventListener('mousemove', this.onMouseMoveEv);
    };
    window.addEventListener('mousemove', this.onMouseMoveEv);
  }

  enter(posttype, hide, hideposttype) {
    if(hideposttype){
      const that = this;
      gsap.set(that.DOM.el.querySelectorAll('[data-type]'), {display: 'none'});
      gsap.to(this.DOM.text, {
        duration: 0.3,
        ease: 'power3.out',
        scale: 0,
      });
    }

    if(hide){
      this.renderedStyles['opacity'].current = 0;
      return;
    }

    if(!posttype && !hideposttype){
      this.renderedStyles['scale'].current = 3;
      this.renderedStyles['opacity'].current = 0.2;
    } else {
      this.DOM.el.querySelector(`[data-type="${posttype}"]`).style.display = 'block';
      this.renderedStyles['scale'].current = 8;
      this.renderedStyles['opacity'].current = 1;
      gsap.to(this.DOM.text, {duration: 0.3, ease: 'power3.out', scale: 1});
    }
  }

  leave(posttype, show) {
    this.renderedStyles['opacity'].current = 1;
    this.renderedStyles['scale'].current = this.enableDefaultCursor;
    const that = this;

    if(posttype){
      gsap.set(that.DOM.el.querySelectorAll('[data-type]'), {display: 'none'});
      gsap.to(this.DOM.text, {
        duration: 0.3,
        ease: 'power3.out',
        scale: 0,
      });
    }

    if(show) {
      this.DOM.el.querySelector(`[data-type="${posttype}"]`).style.display = 'block';
      this.renderedStyles['scale'].current = 8;
      this.renderedStyles['opacity'].current = 1;
      gsap.to(this.DOM.text, {duration: 0.3, ease: 'power3.out', scale: 1});
    }
  }

  render() {
    this.renderedStyles['tx'].current = mouse.x - this.bounds.width/2;
    this.renderedStyles['ty'].current = mouse.y - this.bounds.height/2 - window.scrollY;

    for (const key in this.renderedStyles ) {
      this.renderedStyles[key].previous = lerp(this.renderedStyles[key].previous, this.renderedStyles[key].current, this.renderedStyles[key].amt);
    }

    this.DOM.el.style.transform = `translateX(${(this.renderedStyles['tx'].previous)}px) translateY(${this.renderedStyles['ty'].previous}px)`;
    this.DOM.circle.style.transform = `scale(${this.renderedStyles['scale'].previous})`;
    this.DOM.circle.style.opacity = this.renderedStyles['opacity'].previous;

    requestAnimationFrame(() => this.render());
  }
}
